import React, { useState, useEffect, useContext, useRef } from 'react'
import CustomerCreditAccountHeader from './CustomerCreditAccountHeader'
import CustomerCreditAccountInner from './CustomerCreditAccountInner'
import CustomerCreditAccountFooter from './CustomerCreditAccountFooter'
import ReceiptController from '../../receipt/receipt/ReceiptController'
import { getReceiptsList, getCustomerAccountById, saveCustomer, getInvoiceById,
  saveInvoice } from '../CustomersAccountsFunctions'
import { appContext } from '../../../App'

export const customerCreditAccountControllerContext = React.createContext()

function useCustomerCreditAccountController(props) {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const { customerAccountId, creditAccountNumber } = props
  const [customerAccount, setCustomerAccount] = useState(null)
  const [creditAccount, setCreditAccount] = useState(null)
  const [invoicesUpdated, setInvoicesUpdated] = useState(false)
  const [receiptsList, setReceiptsList] = useState(null)
  const [tabContent, setTabContent] = useState(0)
  let payClickedRef = useRef(false)

  const reloadCustomerCreditAccount = () => {
    getCustomerAccountById(app, customerAccountId)
    .then((res) => {
      const credit_account = res.credit_accounts.find(ca => ca.credit_account_number === creditAccountNumber)
      credit_account.status = (credit_account.status !== 'Settled') ? 'On Process' : 'Settled'
      setCreditAccount(credit_account)
      setCustomerAccount(res)
    })
  }

  const addInvoices = (invoices) => {
    setCreditAccount({ ...creditAccount, invoices: [...creditAccount.invoices, ...invoices] })
    setInvoicesUpdated(true)
  }

  const removeInvoice = async (invoice_number) => {
    setCreditAccount({
      ...creditAccount,
      invoices: [...creditAccount.invoices.filter(invoice => invoice.invoice_number !== invoice_number)]
    })

    const invoice = await getInvoiceById(app, invoice_number)
    invoice.status = 'Unpaid'
    invoice.customer_account_link = null
    invoice.signed_in = app.client.signed_in

    await saveInvoice(app, invoice)

    setInvoicesUpdated(true)
  }

  const setPayClicked = (val) => {
    payClickedRef.current = val
    const receipt_for = {
      item_name: 'Customer Credit Account',
      item: customerAccount
    }
    setContent(<ReceiptController receipt_for={receipt_for}/>)
  }

  const updateCreditAccountView = async () => {
    if (customerAccount) {
      const credit_account = customerAccount.credit_accounts.find(ca => ca.credit_account_number === creditAccountNumber)
      credit_account.invoices = creditAccount.invoices

      await saveCustomer(app, customerAccount)
      reloadCustomerCreditAccount()
    }
  }

  useEffect(() => {
    if (invoicesUpdated) updateCreditAccountView()
    return (() => setInvoicesUpdated(false))
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoicesUpdated])

  useEffect(() => {
    reloadCustomerCreditAccount()
    getReceiptsList(app).then(receipts_list => {
      setReceiptsList(
        receipts_list
        .filter(receipt => receipt.receipt_for.item_name === 'Customer Credit Account')
        .filter(cr => cr.receipt_for.item_id.customer_account_id === customerAccountId)
        .filter(ccr => ccr.receipt_for.item_id.credit_account_number === creditAccountNumber)
      )
    })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const obj = {
    tabContent: [tabContent, setTabContent],
    addInvoices,
    removeInvoice,
    customerAccount,
    creditAccount,
    receiptsList,
    reloadCustomerCreditAccount,
    setPayClicked
  }
  return (obj)
}

function CustomerCreditAccountController(props) {
  const customerCreditAccountController = useCustomerCreditAccountController(props)
  return (
    <React.Fragment>
      <customerCreditAccountControllerContext.Provider value={customerCreditAccountController}>
        <CustomerCreditAccountHeader />
        <CustomerCreditAccountInner />
        <CustomerCreditAccountFooter />
      </customerCreditAccountControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(CustomerCreditAccountController)